import { useSelector } from 'react-redux';
import classNames from 'classnames';
import styles from './FJGenerateStatus.module.less';
import SuccessIcon from '../../../assets/svg/success.svg?react';
import WaitingIcon from '../../../assets/svg/waiting.svg?react';
import FJLocalStore from '../../../store/FJLocalStore';
import PropTypes from 'prop-types';
import FJLoading from '../FJLoading/FJLoading';
import FJConstant from '../../../constants/FJConstant';
import { useMemo } from 'react';
import useIsMobile from '../../../hooks/useIsMobile';
import FJAppConstant from '../../../constants/FJAppConstant';

const FJGenerateStatus = props => {
    const {
        taskStatus,
        onCancel,
        progress = 0,
        currentQueue = 0,
        queueNumber = 0,
        type,
        className,
        isShowProgress = false, // 不显示显示进度
        position = 'right',
    } = props;

    const appType = useSelector(state => state.common.appType);
    const cn = classNames(styles.box, className, type === FJConstant.SMALL ? styles.small : '');
    const isMobile = useIsMobile();
    const isHideSuccess = useMemo(() => {
        if (isMobile) {
            return (
                FJAppConstant.IMAGE_ENHANCER === appType ||
                FJAppConstant.PHOTO_COLORIZE === appType ||
                FJAppConstant.PHOTO_RESTORATION === appType
            );
        }
        return true;
    }, [appType]);
    const generatingText = useMemo(() => {
        if (FJAppConstant.OBJECT_ERASER === appType) {
            return 'removing';
        }
        // return isShowProgress
        //     ? FJLocalStore._('generating-number').replace('xxx', progress + '%')
        //     : FJLocalStore._('generating');
        return 'generating';
    }, [progress, isShowProgress, appType]);
    return (
        <div className={cn}>
            <div
                className={classNames(
                    styles.transition_box,
                    styles[position],
                    styles.start,
                    taskStatus === FJConstant.START ? styles.show : styles.hide,
                )}
            >
                <span className={styles.text}>{FJLocalStore._('starting')}</span>
                <div className={classNames(styles.icon_box, styles.start_icon)}>
                    <FJLoading style={{ height: 12, width: 12 }} />
                </div>
            </div>
            <div
                className={classNames(
                    styles.transition_box,
                    styles[position],
                    styles.waiting,
                    taskStatus === FJConstant.WAITING ? styles.show : styles.hide,
                )}
            >
                {onCancel && (
                    <div className={classNames(styles.cancel_btn, isMobile ? styles.mobile : '')} onClick={onCancel}>
                        {FJLocalStore._('cancel')}
                    </div>
                )}
                <span className={styles.text}>
                    {FJLocalStore._('in-the-queue-number').replace('xx', currentQueue).replace('xxx', queueNumber)}
                </span>
                <div className={classNames(styles.icon_box, styles.waiting_icon)}>
                    <WaitingIcon />
                </div>
            </div>
            <div
                className={classNames(
                    styles.transition_box,
                    styles[position],
                    styles.generating,
                    taskStatus === FJConstant.GENERATING ? styles.show : styles.hide,
                )}
            >
                {onCancel && (
                    <div className={classNames(styles.cancel_btn, isMobile ? styles.mobile : '')} onClick={onCancel}>
                        {FJLocalStore._('cancel')}
                    </div>
                )}
                <span className={styles.text}>{FJLocalStore._(generatingText)}</span>
                <div className={classNames(styles.icon_box, styles.generating_icon)}>
                    <FJLoading style={{ height: 12, width: 12 }} />
                </div>
            </div>
            <div
                className={classNames(
                    styles.transition_box,
                    styles[position],
                    styles.success,
                    taskStatus === FJConstant.SUCCESS && !isHideSuccess ? styles.show : styles.hide,
                )}
            >
                <span className={styles.text}>{FJLocalStore._('success')}</span>

                <div className={classNames(styles.icon_box, styles.success_icon)}>
                    <SuccessIcon />
                </div>
            </div>
        </div>
    );
};
FJGenerateStatus.propTypes = {
    taskStatus: PropTypes.string,
    onCancel: PropTypes.func,
    progress: PropTypes.number,
    currentQueue: PropTypes.number,
    queueNumber: PropTypes.number,
    type: PropTypes.string,
    className: PropTypes.string,
    isShowProgress: PropTypes.bool,
    position: PropTypes.string,
};
export default FJGenerateStatus;
